import { apiRequest } from "./client";
import {
    ArtistCategory,
    ArtistCategoryCreatePayload,
    ArtistCategoryUpdatePayload,
    ArtistCreatePayload,
    ArtistItem,
    ArtistUpdatePayload,
    SeoCreatePayload,
    SeoItem,
    SeoUpdatePayload,
    SlideshowCreatePayload,
    SlideshowImageUploadResponse,
    SlideshowItem,
    SlideshowUpdatePayload,
    TextPageCreatePayload,
    TextPageItem,
    TextPageUpdatePayload,
} from "../types/content.types";

export const getArtistCategoriesRequest = async (): Promise<ArtistCategory[]> => {
    return apiRequest<ArtistCategory[]>("/content/artist-categories", {
        method: "GET",
        auth: true,
    });
};

export const createArtistCategoryRequest = async (
    payload: ArtistCategoryCreatePayload
): Promise<ArtistCategory> => {
    return apiRequest<ArtistCategory>("/content/artist-categories", {
        method: "POST",
        body: JSON.stringify(payload),
        headers: {
            "Content-Type": "application/json",
        },
        auth: true,
    });
};

export const updateArtistCategoryRequest = async (
    categoryId: string,
    payload: ArtistCategoryUpdatePayload
): Promise<ArtistCategory> => {
    return apiRequest<ArtistCategory>(`/content/artist-categories/${categoryId}`, {
        method: "PATCH",
        body: JSON.stringify(payload),
        headers: {
            "Content-Type": "application/json",
        },
        auth: true,
    });
};

export const getArtistsRequest = async (): Promise<ArtistItem[]> => {
    return apiRequest<ArtistItem[]>("/content/artists", {
        method: "GET",
        auth: true,
    });
};

export const createArtistRequest = async (
    payload: ArtistCreatePayload
): Promise<ArtistItem> => {
    return apiRequest<ArtistItem>("/content/artists", {
        method: "POST",
        body: JSON.stringify(payload),
        headers: {
            "Content-Type": "application/json",
        },
        auth: true,
    });
};

export const updateArtistRequest = async (
    artistId: string,
    payload: ArtistUpdatePayload
): Promise<ArtistItem> => {
    return apiRequest<ArtistItem>(`/content/artists/${artistId}`, {
        method: "PATCH",
        body: JSON.stringify(payload),
        headers: {
            "Content-Type": "application/json",
        },
        auth: true,
    });
};

export const getTextPagesRequest = async (): Promise<TextPageItem[]> => {
    return apiRequest<TextPageItem[]>("/content/text-pages", {
        method: "GET",
        auth: true,
    });
};

export const createTextPageRequest = async (
    payload: TextPageCreatePayload
): Promise<TextPageItem> => {
    return apiRequest<TextPageItem>("/content/text-pages", {
        method: "POST",
        body: JSON.stringify(payload),
        headers: {
            "Content-Type": "application/json",
        },
        auth: true,
    });
};

export const updateTextPageRequest = async (
    pageId: string,
    payload: TextPageUpdatePayload
): Promise<TextPageItem> => {
    return apiRequest<TextPageItem>(`/content/text-pages/${pageId}`, {
        method: "PATCH",
        body: JSON.stringify(payload),
        headers: {
            "Content-Type": "application/json",
        },
        auth: true,
    });
};

export const getSlideshowsRequest = async (): Promise<SlideshowItem[]> => {
    return apiRequest<SlideshowItem[]>("/content/slideshows", {
        method: "GET",
        auth: true,
    });
};

export const createSlideshowRequest = async (
    payload: SlideshowCreatePayload
): Promise<SlideshowItem> => {
    return apiRequest<SlideshowItem>("/content/slideshows", {
        method: "POST",
        body: JSON.stringify(payload),
        headers: {
            "Content-Type": "application/json",
        },
        auth: true,
    });
};

export const updateSlideshowRequest = async (
    slideshowId: string,
    payload: SlideshowUpdatePayload
): Promise<SlideshowItem> => {
    return apiRequest<SlideshowItem>(`/content/slideshows/${slideshowId}`, {
        method: "PATCH",
        body: JSON.stringify(payload),
        headers: {
            "Content-Type": "application/json",
        },
        auth: true,
    });
};

export const uploadSlideshowImageRequest = async (
    slideshowId: string,
    file: File
): Promise<SlideshowImageUploadResponse> => {
    const formData = new FormData();
    formData.append("file", file);

    return apiRequest<SlideshowImageUploadResponse>(
        `/content/slideshows/${slideshowId}/upload-image`,
        {
            method: "POST",
            body: formData,
            auth: true,
        }
    );
};

export const getSeoRequest = async (): Promise<SeoItem[]> => {
    return apiRequest<SeoItem[]>("/content/seo-records", {
        method: "GET",
        auth: true,
    });
};

export const createSeoRequest = async (
    payload: SeoCreatePayload
): Promise<SeoItem> => {
    return apiRequest<SeoItem>("/content/seo-records", {
        method: "POST",
        body: JSON.stringify(payload),
        headers: {
            "Content-Type": "application/json",
        },
        auth: true,
    });
};

export const updateSeoRequest = async (
    seoId: string,
    payload: SeoUpdatePayload
): Promise<SeoItem> => {
    return apiRequest<SeoItem>(`/content/seo-records/${seoId}`, {
        method: "PATCH",
        body: JSON.stringify(payload),
        headers: {
            "Content-Type": "application/json",
        },
        auth: true,
    });
};
